import { motion } from "framer-motion";

const SIGILS = {
  freedom: {
    paths: [
      "M 74 30 A 28 28 0 1 0 74 70",
      "M 68 34 L 94 10",
      "M 85 11 L 94 10 L 92 19",
    ],
  },
  chaos: {
    paths: [
      "M 14 72 C 26 18 44 88 58 26",
      "M 30 20 C 52 62 66 10 86 66",
      "M 12 44 C 40 30 60 74 88 40",
    ],
  },
  truth: {
    paths: [
      "M 50 6 L 50 94",
      "M 50 30 L 66 50 L 50 70 L 34 50 Z",
      "M 18 50 L 34 50",
      "M 66 50 L 82 50",
    ],
  },
  grit: {
    paths: [
      "M 12 64 L 30 34 L 46 58 L 62 24 L 78 54 L 90 28",
      "M 12 82 L 30 52 L 46 76 L 62 42 L 78 72 L 90 46",
    ],
  },
  rebellion: {
    paths: [
      "M 26 26 H 74 V 74 H 26 Z",
      "M 12 88 L 88 12",
    ],
  },
  wisdom: {
    circles: [
      [50, 50, 30],
      [50, 50, 19],
      [50, 50, 9],
    ],
    dot: [50, 50],
  },
};

export const Sigil = ({ pillar, size = 96, strokeWidth = 1.6, delay = 0, className = "" }) => {
  const sigil = SIGILS[String(pillar).toLowerCase()];
  if (!sigil) return null;
  const draw = (i) => ({
    initial: { pathLength: 0, opacity: 0 },
    whileInView: { pathLength: 1, opacity: 1 },
    viewport: { once: true, margin: "-40px" },
    transition: { duration: 1.5, delay: delay + i * 0.25, ease: [0.22, 1, 0.36, 1] },
  });
  return (
    <svg
      viewBox="0 0 100 100"
      width={size}
      height={size}
      className={className}
      aria-hidden="true"
      data-testid={`sigil-${String(pillar).toLowerCase()}`}
    >
      {(sigil.paths || []).map((d, i) => (
        <motion.path
          key={i}
          d={d}
          fill="none"
          stroke="#D4AF37"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          {...draw(i)}
        />
      ))}
      {(sigil.circles || []).map(([cx, cy, r], i) => (
        <motion.circle
          key={`c${i}`}
          cx={cx}
          cy={cy}
          r={r}
          fill="none"
          stroke="#D4AF37"
          strokeWidth={strokeWidth}
          {...draw(i)}
        />
      ))}
      {sigil.dot && (
        <motion.circle
          cx={sigil.dot[0]}
          cy={sigil.dot[1]}
          r={2.4}
          fill="#D4AF37"
          initial={{ scale: 0, opacity: 0 }}
          whileInView={{ scale: 1, opacity: 1 }}
          viewport={{ once: true, margin: "-40px" }}
          transition={{ duration: 0.6, delay: delay + (sigil.circles?.length || 0) * 0.25 + 0.3 }}
        />
      )}
    </svg>
  );
};

export default Sigil;
